<script>
import { mapActions, mapState } from 'vuex'
import config from '@/config'

const { DEFAULT_ACCESSIBILITY } = config

export default {
  name: 'Actionbar',
  components: {
    Action: () => import('@/components/general/Action'),
    Dropdown: () => import('@/components/general/Dropdown'),
    DropdownLink: () => import('@/components/general/DropdownLink'),
    Icon: () => import('@/components/general/Icon'),
    Profile: () => import('@/components/general/Profile'),
    SearchBar: () => import('@/components/general/SearchBar')
  },

  props: {
    profile: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      defaultAccessibility: DEFAULT_ACCESSIBILITY,
      increaseFontDisabled: false,
      decreaseFontDisabled: true
    }
  },

  computed: {
    ...mapState([ 'accessibilityFontSize' ]),
    sessionUuid () {
      return this.$route.params.session_uuid
    }
  },

  watch: {
    accessibilityFontSize: function (value) {
      this.increaseFontDisabled = value === 2
      this.decreaseFontDisabled = value === 0
    }
  },

  methods: {
    ...mapActions([
      'setAccessibility',
      'setFontsize'
    ]),

    highContrast () {
      this.setAccessibility()
    },

    increaseFont () {
      this.accessibilityFontSize < 2 && this.setFontsize(this.accessibilityFontSize + 1)
    },

    decreaseFont () {
      this.accessibilityFontSize > 0 && this.setFontsize(this.accessibilityFontSize - 1)
    },

    changeLanguage (language) {
      this.$i18n.locale = language
    }
  }
}
</script>

<template>
  <div class="action-bar">
    <div
      v-if="false"
      class="action-bar-item"
    >
      <SearchBar
        classes="action-bar-link"
        :label="$t('global:actionbar.search.label')"
      />
    </div>

    <div class="action-bar-item" />
  </div>
</template>

<style src="@/assets/styles/themes/default/actionbar.css"></style>
